<template>
  <div>
    <InputBox :height="height">
      <b-menu :activable="false" class="product-list-checkbox">
        <b-menu-list>
          <b-menu-item
            :active="false"
            v-for="product in products"
            :key="product.id"
          >
            <template #label="{ expanded }">
              <div class="main-product-item">
                <div class="is-flex is-align-items-center">
                  <b-icon
                    :icon="setArrow(expanded)"
                    class="mr-3"
                    :class="{ 'is-invisible': !hasGroup(product) }"
                  ></b-icon>
                  <b-icon
                    v-if="product.icon"
                    :icon="product.icon"
                    class="mr-2"
                  ></b-icon>
                  <span>{{ product.name }}</span>
                </div>
                <b-checkbox
                  :value="data.includes(product.id)"
                  @input="
                    checkboxClicked(product.id, !data.includes(product.id))
                  "
                />
              </div>
            </template>
            <template v-if="hasGroup(product)">
              <b-menu-item
                :active="false"
                v-for="group in productGroup(product.id)"
                :key="group.id"
              >
                <template #label>
                  <div class="sub-product-item">
                    <span>{{ group.name }}</span>
                    <b-checkbox
                      :value="dataOwned.includes(group.id)"
                      @input="
                        subCheckboxClicked(
                          product.id,
                          group.id,
                          !dataOwned.includes(group.id)
                        )
                      "
                    />
                  </div>
                </template>
              </b-menu-item>
            </template>
          </b-menu-item>
        </b-menu-list>
      </b-menu>
    </InputBox>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import InputBox from '@/components/helper/InputBox.vue';

export default {
  name: 'ProductListBox',
  components: {
    InputBox,
  },
  props: {
    data: {
      required: true,
      type: Array,
    },
    dataOwned: {
      required: true,
      type: Array,
    },
    height: {
      type: String,
      required: false,
      default: 'auto',
    },
  },
  data() {
    return {
      opened: {},
    };
  },
  computed: {
    ...mapGetters({
      products: 'product/data',
      productGroup: 'product/group/dataByParentId',
    }),
  },
  methods: {
    checkboxClicked(id, value) {
      this.$emit('updateProduct', { id, value });
      // console.log('checkboxClicked', id, value);
    },
    //   update(id, value) {
    //     this.$emit('update', { id, value });
    //   },
    //   toggleProductOpen(productId) {
    //     if (productId in this.opened) {
    //       this.opened[productId] = !this.opened[productId];
    //     } else {
    //       this.opened = { ...this.opened, [productId]: true };
    //     }
    //   },
    subCheckboxClicked(productId, groupId, subscribed) {
      this.$emit('groupClicked', {
        product_id: productId, // int
        permission_group_id: groupId, // int
        subscribed, // bool
      });
    },
    hasGroup(product) {
      return this.productGroup(product.id).length;
    },
    setArrow(expanded) {
      return expanded ? 'angle-down' : 'angle-right';
    },
  },
};
</script>

<style>
.product-list-checkbox .menu-list a {
  padding-left: 0;
  padding-right: 0;
}

.product-list-checkbox .main-product-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.product-list-checkbox .sub-product-item {
  margin-left: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.product-list-checkbox .main-product-item .b-checkbox.checkbox:not(.button) {
  margin-right: 0;
}

.product-list-checkbox .sub-product-item .b-checkbox.checkbox:not(.button) {
  margin-right: 0.25em;
}
</style>
